/* ============================================================
   RACC theme global script: age gate + language toggle.
   JP switches the URL to /ja so Shopify (Localize) serves
   Japanese titles and descriptions. UI labels still font-swap.
   ============================================================ */
(function () {
  function onJa() {
    return window.location.pathname === '/ja' || window.location.pathname.indexOf('/ja/') === 0;
  }

  function applyLang(l) {
    document.querySelectorAll('.lang-en').forEach(function (el) { el.classList.toggle('dn', l !== 'en'); });
    document.querySelectorAll('.lang-jp').forEach(function (el) { el.classList.toggle('dn', l !== 'jp'); });
    var root = document.getElementById('html-root');
    if (root) root.lang = (l === 'jp') ? 'ja' : 'en';
    document.querySelectorAll('.lang-btn').forEach(function (b) { b.classList.remove('active'); });
    var on = document.getElementById('lang-' + l);
    if (on) on.classList.add('active');
    if (typeof window.raccPageSetLang === 'function') { try { window.raccPageSetLang(l); } catch (e) {} }
  }

  // Go to the Japanese or default version of the current page.
  function goToLocale(l) {
    var path = window.location.pathname;
    var rest = window.location.search + window.location.hash;
    var bare = onJa() ? path.replace(/^\/ja/, '') : path;
    if (bare === '') bare = '/';
    var target = (l === 'jp') ? ('/ja' + (bare === '/' ? '' : bare)) : bare;
    window.location.href = target + rest;
  }

  window.raccSetLang = function (l) {
    sessionStorage.setItem('racc_lang', l);
    var needJa = (l === 'jp');
    // Only reload if the URL locale does not already match the choice.
    if (needJa !== onJa()) {
      goToLocale(l);
      return;
    }
    applyLang(l);
  };

  window.raccEnterSite = function (l) {
    sessionStorage.setItem('racc_ok', '1');
    sessionStorage.setItem('racc_lang', l);
    var gate = document.getElementById('age-gate');
    if (gate) gate.classList.add('dismissed');
    var needJa = (l === 'jp');
    if (needJa !== onJa()) {
      goToLocale(l);
      return;
    }
    applyLang(l);
  };

  window.raccDenyEntry = function () {
    var gate = document.getElementById('age-gate');
    if (gate) gate.style.display = 'none';
    var no = document.getElementById('no-age');
    if (no) no.classList.add('show');
  };

  window.raccToggleMobileNav = function () {
    var m = document.getElementById('nav-mobile');
    if (m) m.classList.toggle('open');
  };

  // On load: skip the gate if already passed, and set language from the URL.
  document.addEventListener('DOMContentLoaded', function () {
    // The URL is the source of truth. /ja means Japanese.
    var lang = onJa() ? 'jp' : 'en';
    sessionStorage.setItem('racc_lang', lang);
    if (sessionStorage.getItem('racc_ok')) {
      var gate = document.getElementById('age-gate');
      if (gate) gate.classList.add('dismissed');
    }
    applyLang(lang);
  });
})();
/* ============================================================
   CART DRAWER + QUICK ADD
   ============================================================ */
(function(){
  var GIFT = '42336115228853';   // Gift packaging ¥500
  var HUMI = '51995547893941';   // Humidity pack ¥250
  var money = function(c){ return '¥' + Math.round(c/100).toLocaleString('ja-JP'); };

  function openCart(){
    document.getElementById('cd-overlay').classList.add('show');
    document.getElementById('cd-drawer').classList.add('open');
    document.getElementById('cd-drawer').setAttribute('aria-hidden','false');
  }
  window.raccCloseCart = function(){
    document.getElementById('cd-overlay').classList.remove('show');
    document.getElementById('cd-drawer').classList.remove('open');
    document.getElementById('cd-drawer').setAttribute('aria-hidden','true');
  };

  function getCart(){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){return r.json();});
  }

  function render(cart){
    var body = document.getElementById('cd-body');
    var empty = document.getElementById('cd-empty');
    var foot = document.getElementById('cd-foot');
    body.innerHTML = '';

    var lines = cart.items.filter(function(i){
      return String(i.variant_id) !== GIFT && String(i.variant_id) !== HUMI;
    });
    var addons = cart.items.filter(function(i){
      return String(i.variant_id) === GIFT || String(i.variant_id) === HUMI;
    });

    if(cart.items.length === 0){
      empty.style.display = 'block';
      foot.style.display = 'none';
      return;
    }
    empty.style.display = 'none';
    foot.style.display = 'block';

    lines.forEach(function(it){
      var row = document.createElement('div');
      row.className = 'cd-item';
      row.innerHTML =
        '<div class="cd-item-img"><img src="'+(it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i,'_120x$1$2') : '')+'" alt=""></div>'+
        '<div class="cd-item-main">'+
          '<div class="cd-item-name">'+it.product_title+'</div>'+
          '<div class="cd-item-price">'+money(it.final_price)+'</div>'+
          '<div class="cd-qty">'+
            '<button type="button" class="cd-qty-btn" data-key="'+it.key+'" data-to="'+(it.quantity-1)+'">−</button>'+
            '<span class="cd-qty-n">'+it.quantity+'</span>'+
            '<button type="button" class="cd-qty-btn" data-key="'+it.key+'" data-to="'+(it.quantity+1)+'">+</button>'+
            '<button type="button" class="cd-remove" data-key="'+it.key+'" data-to="0"><span class="lang-en">Remove</span><span class="lang-jp dn">削除</span></button>'+
          '</div>'+
        '</div>';
      body.appendChild(row);
    });

    document.getElementById('cd-total').textContent = money(cart.total_price);
    document.querySelectorAll('.nav-cart-count').forEach(function(el){ el.textContent = cart.item_count; });
    document.getElementById('cd-gift').checked = addons.some(function(a){return String(a.variant_id)===GIFT;});
    document.getElementById('cd-humi').checked = addons.some(function(a){return String(a.variant_id)===HUMI;});

    if(window.raccApplyLang){ window.raccApplyLang(); }
  }

  function refresh(open){
    return getCart().then(function(cart){
      render(cart);
      if(open){ openCart(); }
    });
  }

  function changeByKey(key, qty){
    return fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({id:key, quantity:qty})
    }).then(function(r){return r.json();});
  }

  function addVariant(id, qty){
    return fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id:parseInt(id,10), quantity:qty}]})
    }).then(function(r){return r.json();});
  }

  // quick add from a product card
  window.raccQuickAdd = function(variantId, btn){
    if(!variantId) return;
    if(btn){ btn.disabled = true; }
    addVariant(variantId, 1).then(function(){
      return refresh(true);
    }).then(function(){
      if(btn){ btn.disabled = false; }
    }).catch(function(){
      if(btn){ btn.disabled = false; }
    });
  };

  // open the drawer from the nav cart button
  window.raccOpenCart = function(e){
    if(e){ e.preventDefault(); }
    refresh(true);
  };

  // clicks inside the drawer body: qty and remove
  document.addEventListener('click', function(e){
    var t = e.target.closest('.cd-qty-btn, .cd-remove');
    if(!t) return;
    var key = t.getAttribute('data-key');
    var to = parseInt(t.getAttribute('data-to'),10);
    changeByKey(key, to).then(function(){ return refresh(false); });
  });

  // add-on checkboxes
  document.addEventListener('change', function(e){
    var box = e.target.closest('.cd-addon-box');
    if(!box) return;
    var id = box.getAttribute('data-variant');
    if(box.checked){
      addVariant(id, 1).then(function(){ return refresh(false); });
    } else {
      getCart().then(function(cart){
        var line = cart.items.filter(function(i){ return String(i.variant_id)===id; })[0];
        if(line){ changeByKey(line.key, 0).then(function(){ return refresh(false); }); }
      });
    }
  });
})();